export default __webpack_public_path__ + "static/BrownfieldsRedevelopment-a289d05386d13010538b1ea3fd50a3c1.jpg";